import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'

export const TableHeadCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

export const StyledBoxContainerTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}))

export const StyledLineTeengaer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(2),
  cursor: 'pointer',
  marginTop: theme.spacing(2),
}))
